// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"f9e31462","351":"eaf78c95","581":"0bc4fdb7","591":"d87a3524","606":"590490f2"}[chunkId] + ".chunk.js";
};